// Note: The first file of a module here, must also register the module

import "./archive-effort-dialog.component";
import "./effort-form.component";
import "./effort-list.component";
import "./effort-types-list.component";
